import React from 'react';

import ExpansionPanel from '../../../../components/ExpansionPanel/ExpansionPanel';
import SwitchToggle from '../../../../components/SwitchToggle/SwitchToggle';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';

const DCExpansionPanel = (props) => {
    const {index, title, innerText, onChange, isActive, testId} = props;

    return (
        <ExpansionPanel className='w-full' innerText={innerText} title={title} index={index}>
            <SwitchToggle
                aria-describedby={index}
                labelId={index}
                isActive={isActive}
                onChange={onChange}
                className={'min-w-[48px]'}
                testId={testId}
                ariaLabelKey={localizationKeys.PREFERENCE_CENTER_PAGE_BTN_SWITCH_TOGGLE_OFF_ARIA_LABEL}
                ariaLabelActiveKey={localizationKeys.PREFERENCE_CENTER_PAGE_BTN_SWITCH_TOGGLE_ON_ARIA_LABEL}
            />
        </ExpansionPanel>
    );
};

export default DCExpansionPanel;
